import { CustomOrder, CustomOrderHistoryList } from '@order/const';
import { StateUtils } from '@spartacus/core';
import { ORDER_FEATURE } from '../root';

export const ORDERS_LIST = '[Order] Online Orders List';
export const ORDER_DETAILS = '[Order] User Order Details';
export const ORDER_REPEAT = '[Order] Order Repeat';
export const ORDER_INVOICE_PAYMENT_ENTITY = '[Order] Order Invoice Payment Entity';

export interface StateWithOrder {
  [ORDER_FEATURE]: OrderState;
}

export interface OrderState {
  ordersList: StateUtils.LoaderState<CustomOrderHistoryList>;
  orderDetails: StateUtils.LoaderState<CustomOrder>;
  orderInvoicePayment: StateUtils.EntityLoaderState<void>;
  orderRepeat: StateUtils.LoaderState<void>;
}
